/* ==========================================================================
   PanelRoom > Client > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { initPeople, destroyPeople } = require('./people');
const { addAge } = require('./people/age');
const { initDelete } = require('./delete');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            data: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            setRoom: people => this.store.dispatch(actions.setRoom(people)),
            change: () => this.store.dispatch(actions.change()),
            enableIncrement: () => this.store.dispatch(actions.enableIncrement()),
            disableIncrement: () => this.store.dispatch(actions.disableIncrement()),
            peopleDisableIncrement: people => {
                this.store.dispatch(actions.peopleDisableIncrement(people));
            },
            peopleEnableIncrement: people => this.store.dispatch(actions.peopleEnableIncrement(people))
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Destroy */
                destroyPeople(this);

                if (this.delete) this.delete.actions.destroy();

                /* Remove from DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean instance */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            setRoom: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_ROOM) return;

                /* Data */
                const { people = [] } = this.store.select('data');

                people.forEach((item, index) => {
                    const { ages, value = 0 } = item;

                    if (ages) {
                        ages.forEach(age => {
                            // index, value: totalPeople
                            addAge(this, { index, ageValue: age, value });
                        });
                    }
                });
            }),
            peopleEnableIncrement: this.store.subscribe((state, action) => {
                if (action.type !== types.PEOPLE_ENABLE_INCREMENT) return;

                if (this.people[action.payload]) this.people[action.payload].counter.increment.actions.enable();
            }),
            peopleDisableIncrement: this.store.subscribe((state, action) => {
                if (action.type !== types.PEOPLE_DISABLE_INCREMENT) return;

                if (this.people[action.payload]) this.people[action.payload].counter.increment.actions.disable();
            }),
            enableIncrement: this.store.subscribe((state, action) => {
                if (action.type !== types.ENABLE_INCREMENT) return;

                this.people.forEach(item => {
                    const { max } = item.counter.config;
                    const { value } = item.counter.store.select('counter');

                    if (value < max) item.counter.increment.actions.enable();
                });
            }),
            disableIncrement: this.store.subscribe((state, action) => {
                if (action.type !== types.DISABLE_INCREMENT) return;

                this.people.forEach(item => {
                    item.counter.increment.actions.disable();
                });
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (!this.config.hasDelete) return this;

        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        /* set inital room */
        const { people = [] } = this.config;
        let total = 0;

        /* Prepare payload */
        const room = {
            people: people.map(item => {
                const { value = 0, ages = false } = item;
                total += value;

                if (ages) return { value, ages };
                return { value };
            }),
            total
        };

        /* Dispatch action */
        this.actions.setRoom(room);

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Init Childrens */
        initPeople(this);

        /* Init Delete */
        initDelete(this);

        /* Start */
        this.start();

        return this;
    }
};

/* Exports */
module.exports = prototype;
